const GEN_COOKIE_4AI_JS_URI = 'scripts/cookie_4ai.080b3905.js';
const GEN_COOKIE_4AI_CSS_URI = 'styles/cookie/cookie_4ai.4c548a85.css';
const GEN_BOBBY_JS_URI = 'scripts/bobby.443bbace.js';
const GEN_WEBPUSH_JS_URI = 'scripts/webpush.0cb854f8.js';
const GEN_OFFLINE_JS_URI = 'scripts/offline.22b00d7b.js';
let events_waiter = [];

window.dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}

function loadCookieConsent() {
    return new loadExt([
        assetUrl(GEN_COOKIE_4AI_JS_URI),
        assetUrl(GEN_COOKIE_4AI_CSS_URI)
    ], () => {
        document.addEventListener('click', function(e) {
            let target = e.target;
            if(target && target.closest('#cookieNotice') && target.closest('.confirm')) {
                loadEverything();
            }
        });
        return new cookieConsentJS();
    });
}

function getDefaultsGa() {
    let defaults = {
        'dimension1': 'online',
        'dimension2': 'proxied',
        // send available width x height (not absolute)
        'ScreenResolution': `${window.screen.availWidth}x${window.screen.availHeight}`,
        'ViewportSize': `${document.documentElement.clientWidth}x${document.documentElement.clientHeight}`,
        //'DocumentEncoding': document.inputEncoding,
        'UserLanguage': navigator.language || navigator.userLanguage,
        'DocumentTitle': document.title,
        'UserAgentOverride': navigator.userAgent,
        'TrafficSource': 'Unknown' // ← Initialisation
        /*
        'PageLoadTime': window.performance.timing.loadEventEnd - window.performance.timing.navigationStart,
        'DnsTime': window.performance.timing.domainLookupEnd - window.performance.timing.domainLookupStart,
        'PageDownloadTime': window.performance.timing.responseEnd - window.performance.timing.requestStart,
        'ServerResponseTime': window.performance.timing.responseStart - window.performance.timing.requestStart,
        'DomInteractiveTime': window.performance.timing.domInteractive - window.performance.timing.navigationStart,
        'SessionControl': undefined,
        'UserTimingCategory': undefined,
        'UserTimingVariableName': undefined,
        'UserTimingTime': undefined,
        'UserTimingLabel': undefined,
        'GeographicalOverride': undefined,
        */
    };

    // campaign info
    if (location.search) {
        const qs = new URLSearchParams(location.search);
        const keys = {
            utm_id: 'CampaignId',
            utm_source: 'CampaignSource',
            utm_medium: 'CampaignMedium',
            utm_campaign: 'CampaignName',
            utm_term: 'CampaignKeyword',
            utm_content: 'CampaignContent'
        };
        for (const [utmkey, trackkey] of Object.entries(keys)) {
            if (qs.has(utmkey)) {
                defaults[trackkey] = qs.get(utmkey);
            }
        }
    }

    
    if (!defaults.CampaignSource) {
        const ref = document.referrer;
        if (!ref) {
            defaults.TrafficSource = 'Direct';
        } else if (ref.includes('google.') || ref.includes('bing.') || ref.includes('yahoo.')) {
            if (qs.get('utm_medium') === 'cpc' || qs.get('utm_medium') === 'paid') {
                defaults.TrafficSource = 'Paid Search';
            } else {
                defaults.TrafficSource = 'Organic';
            }
        } else if (ref.includes('facebook.') || ref.includes('linkedin.') || ref.includes('twitter.') || ref.includes('instagram.')) {
            defaults.TrafficSource = 'Social';
        } else if (ref.includes('chat.openai.com')) {
            defaults.TrafficSource = 'IA - ChatGPT';
        } else if (ref.includes('bard.google.com') || ref.includes('gemini.google.com')) {
            defaults.TrafficSource = 'IA - Google Gemini';
        } else if (ref.includes('copilot.microsoft.com') || ref.includes('bing.com')) {
            defaults.TrafficSource = 'IA - Copilot';
        } else {
            defaults.TrafficSource = 'Referral';
        }
    } else if (qs.get('utm_medium') === 'cpc' || qs.get('utm_medium') === 'paid') {
        defaults.TrafficSource = 'Paid Search';
    } else {
        defaults.TrafficSource = defaults.CampaignSource;
    }

    // Stocke la source en localStorage
    localStorage.setItem('lead_source', defaults.TrafficSource);

    return Object.assign({}, defaults, js_params.bobby_data);
}

function loadBobby() {

    return new loadExt([
        assetUrl(GEN_BOBBY_JS_URI)
    ], () => {
        gap('send', 'pageview', getDefaultsGa());
    });
}

function loadGoogleAnalytics() {

    /* DEFAULT FROM GOOGLE
    loadExt(['https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + '.js']);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', js_params.ga_uid);*/
    gtag('js', new Date());
    let real_uid = js_params.ga_tool == 'gtm' ? js_params.ga_gtm : js_params.ga_uid;
    let gtmUrl = (js_params.ga_tool == 'gtm') ? 'https://www.googletagmanager.com/gtm.js?id=' + js_params.ga_gtm : 'https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + ".js";
    return new loadExt([
        gtmUrl
    ], () => {
        console.debug("GTAG : Google tag manager initié avec l'id suivant : " + real_uid);
        // Test gaData to acknowledge adblocker/anti-tracking usage
        if (window.gaData !== undefined || window.google_tag_manager !== undefined) {
            // Set default value of custom dimension 1 to 'online' (GA4)
            gtag('config', real_uid, {
                'siteSpeedSampleRate': js_params.siteSpeedSampleRate || 1,
                'anonymize_ip': true,
                'dimension1': 'online'
            });
            if (events_waiter.length !== 0) {
                events_waiter.forEach((el, index, obj) => {
                    firePlmEvent(el);
                    obj.splice(index, 1);
                });
            }

        } else {
            // If consent OK but adblocker active, server method triggered
            console.debug("Server hit");
            loadBobby();
        }
    });

    /* OLD
    window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments)
    };
    ga.l = +new Date;
    ga('create', js_params.ga_uid, 'auto', {'siteSpeedSampleRate': js_params.siteSpeedSampleRate || 1});
    // Set default value of custom dimension 1 to 'online'
    ga('set', 'dimension1', 'online');

    return new loadExt([
        'https://www.google-analytics.com/analytics.js'
    ], () => {
        console.debug("GA : Google analytics initié avec l'id suivant : " + js_params.ga_uid);
        ga('send', 'pageview');
    })*/

}

function loadWebPush() {
    return new loadExt([
        assetUrl(GEN_WEBPUSH_JS_URI)
    ], async () => {
        webPushInit();
    });
}

function loadServiceWorker() {
    const env = window.location.host === 'www.artwai.com' ? 'prod' : 'dev';
    return new loadExt([
        assetUrl(`lib/workbox/workbox-window.${env}.umd.js`),
        assetUrl(GEN_OFFLINE_JS_URI)
    ], async () => {
        if ('serviceWorker' in navigator) {
            const wb = new workbox.Workbox('/workbox_sw.js');

            wb.addEventListener('waiting', () => {
                new createUIPrompt(
                    'app-update',
                    'La PWA artwai.com doit effectuer une mise à jour.', {
                        onAccept: async () => {
                            wb.messageSW({
                                type: 'CLEAN_CACHE'
                            });

                            wb.addEventListener('controlling', () => {
                                window.location.reload();
                            });

                            wb.messageSW({
                                type: 'SKIP_WAITING'
                            });
                        }
                    }).show();
            });

            wb.register();
            this.dispatchEvent(new CustomEvent('wbregistered', {
                detail: {
                    workbox: wb
                }
            }));
        }
    });
}

function loadEverything() {
    /*loadGoogleAnalytics();*/
    loadEvents();
    if (window.contactFormData !== undefined && window.dataLayer !== undefined) {
        firePlmEvent(cleanPlmEvent(window.contactFormData));
    }
    loadOtherTrackers();
}

/*** START PLAN DE MARQUAGE ***/

function loadEvents() {
    document.addEventListener('click', function (e) {
        let el = e.target.closest('[data-trck]');
        if (el) {
            let data = JSON.parse(el.getAttribute('data-trck'));
            firePlmEvent(cleanPlmEvent(data))
        }
    });
}

function cleanPlmEvent(obj) {
    let dataDefault = {
        'type': 'event',
        'name': 'generic',
        'category': 'all',
        'label': 'generic'
    };
    return Object.assign(dataDefault, obj);
}

function firePlmEvent(obj) {
    if(!(["generic",""].includes(obj.name))) {
        console.debug("GTM Event envoyé");
        let plmEvent = {
            "event": obj.name,
        }
        plmEvent[obj.variable] = obj.label;
        if(obj.hasOwnProperty('fields')) {
            plmEvent['fields'] = obj.fields;
        }
        if(window.dataLayer !== undefined) {
            window.dataLayer.push(plmEvent);
        }
    }
}

function loadOtherTrackers() {
    let scripts = [...document.querySelectorAll("script[type='consent/javascript']")];

    scripts.forEach((script) => {
        let parent = script.parentElement,
            newscript;
        if (!parent) {
            return;
        }
        newscript = document.createElement('script');
        newscript.type = "text/javascript";
        if (script.src) {
            newscript.src = script.src;
        } else {
            newscript.text = script.text;
        }
        parent.removeChild(script);
        parent.appendChild(newscript);
    });
}

/*** END PLAN DE MARQUAGE ***/

window.addEventListener('load', async () => {
    if (is_service_worker_enabled()) {
        loadServiceWorker();
    }
    getDefaultsGa();
});

window.addEventListener('load', async () => {
    if (is_webpush_available()) {
        loadWebPush();
    }
});

window.addEventListener('load', async () => {
    /*let consentStatsObj = readCookie('consent_statistiques');
    let consentStats = '';
    if (consentStatsObj != false) {
        consentStats = JSON.parse(consentStatsObj);
    }

    if (consentStatsObj === false) {
        loadCookieConsent();
        if (js_params.ga_proxy) {
            loadBobby();
        }
    } else if (consentStats.value !== 1 && js_params.ga_proxy) {
        loadBobby();
    } else if (js_params.ga_enabled) {
        
    }*/
    loadEverything();
});

window.addEventListener('load', async () => {
    if (!('indexedDB' in window)) {
        a4ilog.warn('This browser doesn\'t support IndexedDB. Perfomances may be impacted');
        return;
    }

    const db_name = 'memshare';
    const db_version = 2;

    let idb = window.indexedDB;

    // Open a db instance
    let request = idb.open(db_name, db_version);

    request.onerror = (event) => a4ilog.error('Database error: ' + event.target.errorCode);

    // Create or update the database structure
    request.onupgradeneeded = (event) => {
        const db = event.target.result;

        const offlineStore = db.createObjectStore(db_name, {
            keyPath: 'key'
        });
        offlineStore.createIndex('value', 'value');
    };

    request.onsuccess = (event) => {
        // Get db instance
        const db = event.target.result;

        // Open a transaction
        const transaction = db.transaction([db_name], 'readwrite');

        // Select offline-pages object store (table)
        const memshare = transaction.objectStore(db_name);
        const connected = memshare.get('connected');

        connected.onsuccess = () => {
            const connected = document.cookie.search('user_connected') >= 0;
            memshare.put({
                key: 'connected',
                value: connected
            });
        }
    };
});

/** MENU **/
window.addEventListener('DOMContentLoaded', () => {
    /** MENU HIDE FEATURED ON CLICK ***/
    const submenus = document.querySelectorAll('.has_children .sub-menu');
    submenus.forEach(item => {
        const labels = item.querySelectorAll('.menu_label_container');
        const featured = item.querySelectorAll('.last-submenu')[0];
        
        if (labels.length > 0) {
            labels.forEach(label => {
                label.addEventListener('click', () => {
                    featured.style.display = "none";
                }
            )})
        }
    })

    /** HANDLE MENU INPUTS TYPE FO DESKTOP AND MOBILE */
    const inputs = document.querySelectorAll('.input_mobile');
    const resolutionLimit = 1280;
    let resolution = window.innerWidth;

    function changeInputs() {
        if (resolution < resolutionLimit ) {
            inputs.forEach((item) => {
                item.type = 'checkbox';
            })
        }
    }

    changeInputs();

    window.addEventListener('resize', () => {
        changeInputs();
    })
})
